import PresentationActions from "./PresentationActions";
import PresentationComposition from "./presentations/PresentationComposition";
import PresentationName from "./presentations/PresentationName";
import { ApplicationWithId } from "../../../interfaces/IApplications";
import { Box, Divider } from "@mui/material";
import { CategoryTypes } from "../../../interfaces/enums";
import { CategoryWithId } from "../../../interfaces/ICategories";
import {
  generateDisplayWithYears,
  shouldShowComposition,
} from "./presentations/presentationDisplayUtils";

interface PresentationItemProps {
  presentation: any;
  application: ApplicationWithId;
  category: CategoryWithId;
  onEditPresentation: (presentation: any) => void;
  onDeletePresentation: (presentation: any) => void;
  isLast: boolean;
}

export default function PresentationItem({
  presentation,
  application,
  category,
  onEditPresentation,
  onDeletePresentation,
  isLast,
}: PresentationItemProps) {
  const showComposition = shouldShowComposition(category.type);
  const displayData =
    category.type === CategoryTypes.SOLO ||
    category.type === CategoryTypes.DUO ||
    category.type === CategoryTypes.TRIO
      ? generateDisplayWithYears(presentation, category.type)
      : { text: presentation.name, hasStyledYears: false };

  return (
    <>
      <Box sx={{ py: 1, px: 3 }}>
        {/* Pierwszy wiersz - nazwa zespołu + tytuł + przyciski akcji */}
        <Box
          sx={{
            mb: showComposition ? 2 : 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <PresentationName
            presentation={presentation}
            category={category}
            displayData={displayData}
          />

          <PresentationActions
            application={application}
            presentation={presentation}
            onEditPresentation={onEditPresentation}
            onDeletePresentation={onDeletePresentation}
            category={category}
          />
        </Box>

        {/* Lista zawodników w grid - tylko dla kategorii "Inne" */}
        {showComposition && presentation.participants && presentation.participants.length > 0 && (
          <PresentationComposition presentation={presentation} />
        )}
      </Box>
      {!isLast && <Divider />}
    </>
  );
}
